<template>
  <div class="contract-lease-bd bd" v-if="funcView.leasing_scheme_list">
    <div class="aside">
      <div class="title">
        <i class="icon icon-zuzhi"></i>
        <span>{{ $t('crm_contract_lease.zu_lin_fang_an') }}</span>
      </div>
      <!-- 搜索栏 -->
      <div class="search" style="margin-bottom: 20px">
        <div class="ub">
          <div class="ub-f1">
            <el-input clearable :placeholder="$t('crm_contract_lease.qsrzlfalx')" v-model="searchKey" @input="filterTree"></el-input>
          </div>
          <div style="margin-left: 10px">
            <add-button @click="addLeaseClass()"></add-button>
          </div>
        </div>
      </div>
      <!-- 树形列表 -->
      <div class="tree">
        <el-tree
          ref="tree"
          :data="LeaseClassTree"
          :props="{ children: 'children', label: 'categoryName' }"
          node-key="categoryId"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expand-all="true"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
        >
          <span v-if="data.categoryId === treeItem.categoryId" class="tree-item" slot-scope="{ data }">
            <span class="line1">{{ data.categoryName }}</span>
            <span>
              <el-button type="text" size="mini" @click.stop="addLeaseClass(data)" v-if="funcView.leasing_schemeType_add">
                <i class="icon icon-add"></i>
              </el-button>
              <el-button type="text" size="mini" @click.stop="editLeaseClass(data)" v-if="funcView.leasing_schemeType_edit">
                <i class="icon icon-bianji"></i>
              </el-button>
              <el-button type="text" size="mini" @click.stop="deleteLeaseClass(data)" v-if="funcView.leasing_schemeType_delete">
                <i class="icon icon-shanchu"></i>
              </el-button>
            </span>
          </span>
          <span class="tree-item" v-else>
            <span class="line1">{{ data.categoryName }}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="section">
      <div class="search-hd">
        <el-form :inline="true">
          <el-form-item>
            <el-button @click="addLease" v-if="funcView.leasing_scheme_add" type="primary" icon="el-icon-plus" :disabled="!treeItem.categoryId">{{ funcView.leasing_scheme_add }}</el-button>
          </el-form-item>
          <!-- 配置栏 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input :placeholder="$t('crm_contract_lease.qsrfamcfabh')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <custom-select
              clearable
              v-model="formSearch.productCode"
              :filterable="true"
              url="productCodeSelectList"
              :props="{ label: 'productName', value: 'productCode' }"
              @change="onPageChange({ page: 1 })"
              :placeholder="$t('Common.com_please_select')"
            ></custom-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table height="100%" :index="true" :data="LeaseList" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['sharingType', 'goodsSkuOwner', 'action']">
          <!-- 配置列 -->
          <template slot="sharingType" slot-scope="scope">
            <ul>
              <li v-for="(val, i) in scope.row.conditionList" :key="i">
                {{ val.sharingType }}
              </li>
            </ul>
          </template>
          <template slot="goodsSkuOwner" slot-scope="scope">
            <span v-if="scope.row.goodsSkuOwner">
              {{
                scope.row.goodsSkuOwner
                  .split(',')
                  .map((t) => getDicValue('crm_scheme_owner', t))
                  .join('，')
              }}
            </span>
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="scope">
            <el-button type="text" size="mini" @click="watchLeaseClass(scope.row)" v-if="funcView.leasing_scheme_view">{{ funcView.leasing_scheme_view }}</el-button>
            <el-button type="text" size="mini" :disabled="!scope.row.state" @click="editLease(scope.row)" v-if="funcView.leasing_scheme_edit">{{ funcView.leasing_scheme_edit }}</el-button>
            <el-button type="text" size="mini" :disabled="!scope.row.state" @click="deleteLease(scope.row)" v-if="funcView.leasing_scheme_delete">{{ funcView.leasing_scheme_delete }}</el-button>
            <el-button v-if="scope.row.state && funcView.leasing_scheme_disable" :disabled="!scope.row.state" type="text" size="mini" @click="setStateLease(scope.row)">
              {{ funcView.leasing_scheme_disable }}
            </el-button>
            <el-button v-if="!scope.row.state && funcView.leasing_scheme_enable" type="text" size="mini" @click="setStateLease(scope.row)">{{ funcView.leasing_scheme_enable }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <contract-lease-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getLeaseClassTree()"></contract-lease-dialog>
    <contract-lease-detail v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></contract-lease-detail>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import addButton from '@/components/addButton';
import contractLeaseDialog from './children/contract_lease_dialog.vue';
import contractLeaseDetail from './children/contract_lease_detail.vue';

const i18n = {};
const funcView = {};

export default {
  name: 'contractlease',
  components: { addButton, contractLeaseDialog, contractLeaseDetail },
  data() {
    return {
      provide: true,
      translate: { i18n, funcView },
      tableCode: 'scheme_payment',

      LeaseClassTree: [],
      LeaseList: [],
      totalRows: 0,

      searchKey: '',
      treeItem: {},
      formSearch: {
        categoryId: '',
        productCode: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted() {
    this.getTableColumn();
    // this.getLeaseList();
    this.getFuncView(null, () => {
      this.getLeaseClassTree();
    });
  },
  activated: function () {
    this.getLeaseList();
  },
  methods: {
    // 租赁类型方案
    getLeaseClassTree: function () {
      this.$getJSON(apis.CategoryTree).then((res) => {
        this.LeaseClassTree = res.data || [];
        // if (this.LeaseClassTree.length && this.$refs.tree) {
        //   this.$nextTick(() => {
        //     const categoryId = this.getJump('categoryId');
        //     this.$refs.tree.setCurrentKey(categoryId || this.LeaseClassTree[0].categoryId);
        //   });
        //   this.$nextTick(() => {
        //     const cur = this.$refs.tree.getCurrentNode();
        //     this.handleNodeClick(cur);
        //   });
        // }
      });
    },
    // 新增租赁类型
    addLeaseClass: function (data) {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('crm_contract_lease.xzfalx');
      this.dialogModel.data = data ? { parentId: data.categoryId } : {};
      this.dialogVisible = true;
    },
    // 编辑租赁类型
    editLeaseClass: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('crm_contract_lease.bjfalx');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 删除租赁类型
    deleteLeaseClass: function (data) {
      this.$showConfirm(this.$t('crm_contract_lease.nqdyscsxfalx')).then(() => {
        this.$postJSON(`${apis.CategodyDelete}/${data.categoryId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getLeaseClassTree();
        });
      });
    },
    // 选中租赁类型项
    handleNodeClick: function (row) {
      if (row.categoryId === this.treeItem.categoryId) {
        this.treeItem = {};
        this.LeaseList = [];
        this.getLeaseList();
        this.$refs.tree.setCurrentKey(null);
        return;
      }
      this.treeItem = row;
      this.LeaseList = [];
      this.getLeaseList();
    },
    // 搜索过滤事件
    filterTree: function () {
      this.$refs.tree.filter(this.searchKey);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.categoryName.indexOf(value) !== -1;
    },
    // 租赁方案列表
    getLeaseList: function () {
      this.formSearch.categoryId = this.treeItem.categoryId;
      this.$getJSON(apis.GoodsPage, this.formSearch).then((res) => {
        this.LeaseList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLeaseList();
    },
    // 新增租赁方案
    addLease: function () {
      this.clearTagByKeep('contract_lease_item');
      this.jump('/redirect/offer/contractlease/add', {
        parentPath: '/offer/contractlease',
        categoryId: this.treeItem.categoryId,
      });
    },
    // 编辑租赁方案
    editLease: function (data) {
      this.clearTagByKeep('contract_lease_item');
      this.jump('/redirect/offer/contractlease/edit', {
        parentPath: '/offer/contractlease',
        goodsId: data.goodsId,
        categoryId: this.treeItem.categoryId,
      });
    },
    // 查看租赁方案
    watchLeaseClass: function (data) {
      this.dialogModel1.title = this.$t('crm_contract_lease.ckzlfa');
      this.dialogModel1.row = data;
      this.dialogVisible1 = true;
    },
    // 设置状态规则
    setStateLease: function (data) {
      this.$showConfirm(data.state ? this.$t('crm_contract_lease.qrjyofa', [data.goodsName]) : this.$t('crm_contract_lease.qrqyofa', [data.goodsName])).then(() => {
        this.$postJSON(apis.GoodsState, {
          goodsId: data.goodsId,
          state: data.state ? 0 : 1,
        }).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getLeaseList();
          }
        });
      });
    },
    // 删除方案
    deleteLease: function (data) {
      this.$showConfirm(this.$t('crm_contract_lease.qrscofa', [data.goodsName])).then(() => {
        this.$postJSON(`${apis.GoodsDelete}/${data.goodsId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getLeaseList();
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.contract-lease-bd {
  .aside {
    .title {
      padding: 14px 20px 16px;
      line-height: 24px;
      color: #404040;
      font-weight: bold;
      font-size: 15px;
      .icon {
        font-weight: normal;
        float: left;
        margin-right: 8px;
        font-size: 14px;
      }
    }
    .search {
      margin: 0 20px;
    }
    .is-current > .el-tree-node__content {
      background-color: $main-color;
      .tree-item {
        color: #ffffff;
        .icon {
          color: #ffffff;
          font-size: 12px;
        }
        .disable {
          color: #ffffff;
        }
      }
    }
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 8px;
      width: 0;
      .disable {
        color: #bfbfbf;
      }
    }
  }
}
</style>
